/* eslint-disable space-in-parens */
import React from 'react'
import PropTypes from 'prop-types'
import * as EmailValidator from 'email-validator'

class Email extends React.Component {
  static propTypes = {
    sendEmailWithRedux: PropTypes.func,
  }
  constructor (props) {
    super(props)
    window.pro4 = this.state
    this.handleGo = this.handleGo.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.state = {
      email: ''
    }
  }

  handleChange (event) {
    this.setState({ email: event.target.value })
  }
  handleGo (event) {
    this.props.sendEmailWithRedux(this.state.email)
  }
  render () {
    return (
      <div className='table-list'>
        <div className='form-group table-cell'>
          <div className='input-email input-icon'>
            <input className='form-control' placeholder='Thư điện tử - Email' onChange={this.handleChange} />
          </div>
        </div>
        <div className='table-cell'>
          <button disabled={!this.state.email || !(EmailValidator.validate(this.state.email))}
            className='btn btn-primary' onClick={this.handleGo}>Nhận</button>
        </div>
      </div>
    )
  }
}

export default Email



// WEBPACK FOOTER //
// ./src/components/Email.js